import Swal from "sweetalert2";
import { config } from "../config.js";
import { post, get } from './baseApi.service.js';

export const apiGetSetting = async () => {
  try {
    const result = await get("/api/setting", {site: config.site});
    console.log("Raw API Setting Response:", result); // Add debug log
    
    // Return a default webSetting if data is null
    if (result?.status_code === 200) {
      return {
        ...result,
        data: result.data || {
          upload_descriptions: { items: [], by_update_type: {} },
          email: 'default@email.com',
          phone_number: '0000000000',
          link_cskh: '#',
          login_info_notice: ''
        }
      };
    }
  } catch (error) {
    console.error("apiGetSetting error:", error);
    return Swal.fire({ icon: "error", text: "Lỗi kết nối, vui lòng thử lại sau." });
  }
};

export const apiCheckAccount = async (userName) => {
  let raw = { account: userName };
  try {
    console.log('Checking account with data:', raw);
    const result = await post("/api/user/check", raw);
    console.log("API Check Account Response:", result);
    
    // Handle potential error responses
    if (result?.code === 200) {
      return result;
    } else if (result?.status === 404) {
      throw new Error('API endpoint not found');
    }
    return result;
  } catch (error) {
    console.error("API Check Account Error:", error);
    if (error.response?.status === 404) {
      Swal.fire({ 
        icon: "error", 
        text: "API endpoint không tồn tại. Vui lòng kiểm tra cấu hình." 
      });
    } else {
      Swal.fire({ 
        icon: "error", 
        text: "Thao tác lỗi, vui lòng thử lại sau." 
      });
    }
    return null;
  }
};

export const apiFormUpdateAccount = async (body, files) => {
  try {
    const formData = new FormData();

    // Thêm dữ liệu từ body vào formData
    for (const key in body) {
      formData.append(key, (typeof body[key] === 'object') ? JSON.stringify(body[key]) : body[key] );
    }

    // Thêm files vào formData (nếu có)
    if (files && files.length > 0) {
      files.forEach((file) => {
        formData.append("files", file);
      });
    }
    const result = await post("/api/user/form-info-update",formData);
    if (result.code === 200) {
      return result.data;
    } else {
      Swal.fire({
        icon: "error",
        title: result.error,
        text: result.message,
      });
      return false;
    }
  } catch (error) {
    console.error("error", error);
  }
};

export const apiUpdateAccount = async (body) => {
  let raw = body;
  try {
    const result = await post("/api/user/info-update",raw);
    if (result.code === 200) {
      return true;
    } else {
      Swal.fire({
        icon: "error",
        title: result.error,
        text: result.message,
      });
      return false;
    }
  } catch (error) {
    console.error("error", error);
  }
};

export const apiCheckDataAccount = async (body) => {
  let raw = body;
  try {
    const result = await post("/api/user/check-data-old",raw);
    if (result.code === 200) {
      return result.data;
    } else {
      if(result.code === 202) {
        Swal.fire({
          icon: "error",
          title: result.error,
          text: result.message,
        });
      }
      return false;
    }
  } catch (error) {
    console.error("error", error);
  }
};

export const apiConfirmUpdate = async (body) => {
  let myHeaders = new Headers();
  myHeaders.append("Content-Type", "application/json");
  let raw = JSON.stringify(body);
  let requestOptions = {
    method: "POST",
    headers: myHeaders,
    body: raw,
  };

  try {
    const response = await fetch(`${config.BE_API_URL}/api/user/confirm-update`, requestOptions);
    const result = await response.json();
    if (result.code === 200) {
      return result.data;
    } 
  } catch (error) {
    console.error("error", error);
  }
};

export const apiGetRequestHistory = async (account, requestCode) => {
  try {
    return await post("/api/user/request-history", {
      account,
      request_code: requestCode,
    });
  } catch (error) {
    console.error("apiGetRequestHistory error", error);
    return null;
  }
};

// danh sách ngân hàng cho khách chọn: [{ code, name }]
export const apiGetBanks = async () => {
  try {
    const result = await get("/api/bank", {site: config.site});
    if (result?.status_code === 200) {
      return result.data;
    }
    return [];
  } catch (error) {
    return [];
  }
};
